// --------------------------------------------------------------
// Created On: 2026-03-13
// Author: Dimitra Weinstein
//
// Last Modified: 2026-03-19
// Modified By: Zachary Thomas
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------
import React from "react";
import Modal from "src/components/Modal/Modal";
import ModalBody from "src/components/ModalBody/ModalBody";
import ModalFooter from "src/components/ModalFooter/ModalFooter";
import ModalHeader from "src/components/ModalHeader/ModalHeader";
import Error from "src/components/Error/Error";
import styles from "./DeviceConfigurationModal.module.scss";
import Spinner from "src/components/Spinner/Spinner";

// Modal for viewing a JSON representation of a monitoring device's current configuration.
export default function DeviceConfigurationModal(props: Props): Component {
  return (
    <div>
      <Modal
        show={props.showModal}
        onHide={() => props.onClose()}
        backdropClassName="super-modal-backdrop"
        style={{ zIndex: "var(--super-modal-z-index)" }}
        size="xl"
        animation
        centered
      >
        <ModalHeader className={`${styles.modalHeader}`}>
          <div className="container h-100">
            <div className="row">
              <h4 className="font-weight-bold text-center text-white">Configuration</h4>
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          <Spinner loading={props.loading} inline={true} />
          {props.deviceConfigurationDetails && (
            <pre>{JSON.stringify(JSON.parse(props.deviceConfigurationDetails), null, 2)}</pre>
          )}
          <Error message={props.errorMessage} />
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-primary" type="button" onClick={() => props.onClose()}>
            Close
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

interface Props {
  loading: boolean;
  showModal: boolean;
  errorMessage: string;
  deviceConfigurationDetails: string;
  onClose: () => void;
}
